import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  OnInit,
  DoCheck
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { VhQueryAutoWeb } from 'vhautowebdb';
// import { ChooseIconComponent  } from '../../choose-icon/choose-icon.component';
@Component({
  selector: 'atw-config-zalo-follow',
  templateUrl: './zalo-follow-config-button.component.html',
  styleUrls: ['./zalo-follow-config-button.component.scss'],
})
export class AtwZaloFollowConfig implements OnInit {
  isCollapsed: boolean = false;
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  facebookID: string = '' // Biến lấy giá trị của Facebook ID

  currentViewAll: any = {};
  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  fieldSettingEffect: string = '';
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb, 
  ) {}
  ngOnInit(): void {
    
  }
  ngOnDestroy() {
    this.saveDataProperties();
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  } 

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name, value) {
    // lấy tên và giá trị style đã thay đổi.
    this.dataAfterChange[name] = { ...value };
  }

  /**
   * Cập nhật lưu hàm updateCss vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb
        .updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then(
          (bool) => {
            
          },
          (error) => {
            console.error(error);
          }
        );
  }

  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then(
      (bool) => {
        
      },
      (error) => {
        console.error(error);
      }
    );
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
